import { mapActions, mapGetters, mapState } from "vuex";

export default {
  props: ["customSysMsgName"],
  created() {
    let smn = this.customSysMsgName;
    if (
      smn &&
        smn.length &&
        smn[smn.length - 1].type === "notify"
    ) return;
  },
  methods: {
    ...mapActions({
      setCurrentSession: "im/setCurrentSession",
    }),
    close() {
      this.setCurrentSession();
    },
  },
  computed: {
    ...mapState('user', ['userTpId']),
    ...mapState('im', ['currentSession', 'author', 'teamsList']),
    ...mapGetters('im', ['teamsMap', 'singleMap', 'currentTeamUsersMap', 'sessionsMap']),
    ...mapState("im", ["UIControl", "driverChatList", "friends", "groups", "recentList"]),
    fiflterNotOwnerList() {
      if(this.teamsMap[this.currentSession].masterTpId === (this.isCommand ? this.userTpId : this.dspTpId)) {
        return this.groupMoreList.filter(item => item.title !== 'Leave Group')
      }
      return this.groupMoreList.filter(item => item.title === 'Leave Group')
    },
    isHideHeader() {
      if(this.currentSession) {
        return this.currentSession == 'SYSTEM' ? false : true
      }
    },
    name() {
      let smn = this.customSysMsgName;
      if (
        smn &&
        smn.length &&
        smn[smn.length - 1].type === "notify"
      ) {
        return "Notification";
      }

      if (!this.currentSession) return;
      const info = this.singleMap[this.currentSession]
      return (info?.clientUserName || '').trim() || info?.email;
    },
    /**
     * 判断是否是group
     */
    isGroup() {
      return this.currentSession && this.teamsMap[this.currentSession]
    },
    groupInfo() {
      return (this.currentSession && this.teamsMap[this.currentSession]) || {}
    },
    singleInfo() {
      return (this.currentSession && this.singleMap[this.currentSession]) || null
    }
  }
}
